// extracted by mini-css-extract-plugin
module.exports = {"shimmer":"RfqModal_shimmer__MS4eH"};